<template>
  <div>
    <Header :title="$t('wallet.title')" />
    <div class="full-page-box">
      <div class="img-box">
        <img src="../../assets/imgs/wallet/1.png" />
      </div>
      <div style="width: 90%; margin: 30px auto 0">
        <van-button class="btn" @click="toGet">{{
          $t("wallet.btn")
        }}</van-button>
      </div>
      <div class="img-box">
        <img src="../../assets/imgs/wallet/2.png" />
      </div>

      <div class="img-box">
        <img src="../../assets/imgs/wallet/bank.png" />
      </div>
    </div>
    <Footer />
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="withdrawal-box">
            <div class="title">{{ $t("wallet.getmoneytitle") }}</div>
            <div class="balance">
              {{ $t("wallet.balance") }}: {{ banlance }} {{ $t("common.unit") }}
            </div>
            <van-form @submit="onSubmit">
              <van-field
              class="input"
                v-model="money"
                :placeholder="$t('wallet.moneydesc')"
                :rules="[{ required: true}]"
              />
              <van-field
              class="input"
                type="password"
                v-model="code"
                :placeholder="$t('wallet.codedesc')"
                :rules="[{ required: true }]"
              />
              <div style="margin: 16px;text-align: center;">
                <van-button class="btnok" native-type="submit"
                  >{{ $t('common.confirm') }}</van-button
                >
                &nbsp;&nbsp;&nbsp;
                <van-button class="btncancel" @click="show=false"
                  >{{ $t('common.cancel') }}</van-button
                >
              </div>
            </van-form>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
import { Toast } from "vant";
export default {
  name: "WalletView",
  components: { Footer, Header },
  data() {
    return {
      show: false,
      money: 0,
      code: null,
      banlance: 0,
      withdrawRole: {},
      options: [],
      options1: [],
    };
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    } else {
    this.getInfo()
    this.getUserWithdrawRole();
    }
  },
  methods: {
    toGet() {
      this.show = true;
    },
    onSubmit(){
      this.doWithdraw()
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.banlance = res.data.money
          }
        } else  {
          Toast(res.msg);
        }
      });
    },
    doWithdraw() {
      if (this.money <= 0) { 
        Toast(this.$t("setting.correct_money"));
        return false;
      } else {
        this.$http({
          method: "post",
          data: { money: this.money,paypassword:this.code },
          url: "user_set_withdraw",
        }).then((res) => {
          if (res.code ===200) {
            location.reload();
            this.show=false
            Toast(res.msg);
            this.getInfo();
            this.getUserWithdrawRole();
          } else {
            Toast(res.msg);
          }
        });
      }
    },
    getUserWithdrawRole() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_role",
      }).then((res) => {
        if (res.code == 200) {
          this.withdrawRole = res.data;
          this.options = this.withdrawRole.bank;
          this.options1 = []
          this.options.forEach(element => {
            this.options1.push(element.name)
          });
        } else {
          Toast(res.msg);
        }
      });
    }
  },
};
</script>
<style scoped>
.img-box {
  width: 96%;
  margin: 10px auto;
}
.img-box img {
  width: 100%;
  border-radius: 8px;
}
.btn {
  background-color: rgb(4, 109, 181);
  border-radius: 8px;
  color: #fff;
  width: 100%;
}
.withdrawal-box {
    padding: 10px;
}
.withdrawal-box .title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    line-height: 1.8;
}
.withdrawal-box .balance {
    line-height: 1.8;
}
.withdrawal-box .input {
    border:1px solid rgb(156 163 175) !important;
    background-color: #fff !important;
    border-radius: 8px;
    margin-top: 10px;
}
.withdrawal-box .btnok {
    border-radius: 8px;
    background-color: rgb(239 68 68);
    color: #fff;
}
.withdrawal-box .btncancel {
    border-radius: 8px;
    background-color: rgb(209 213 219);
}
</style>
